import "./ScrollToTop.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

function CustomScrollToTop() {
	return (
		<>
			<FontAwesomeIcon icon={faAngleUp} />
		</>
	);
}

export { CustomScrollToTop };
